import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const QR: FC<SvgProps> = ({ size, className, color, stroke }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.875 4.5C4.66821 4.5 4.5 4.66821 4.5 4.875V9.375C4.5 9.47446 4.53951 9.56984 4.60984 9.64016C4.68016 9.71049 4.77554 9.75 4.875 9.75H9.375C9.58179 9.75 9.75 9.58179 9.75 9.375V4.875C9.75 4.66821 9.58179 4.5 9.375 4.5H4.875ZM3 4.875C3 3.83979 3.83979 3 4.875 3H9.375C10.4102 3 11.25 3.83979 11.25 4.875V9.375C11.25 10.4102 10.4102 11.25 9.375 11.25H4.875C4.37772 11.25 3.90081 11.0525 3.54917 10.7008C3.19754 10.3492 3 9.87228 3 9.375V4.875ZM14.625 4.5C14.4182 4.5 14.25 4.66821 14.25 4.875V9.375C14.25 9.47446 14.2895 9.56984 14.3598 9.64016C14.4302 9.71049 14.5255 9.75 14.625 9.75H19.125C19.3318 9.75 19.5 9.58179 19.5 9.375V4.875C19.5 4.66821 19.3318 4.5 19.125 4.5H14.625ZM12.75 4.875C12.75 3.83979 13.5898 3 14.625 3H19.125C20.1602 3 21 3.83979 21 4.875V9.375C21 10.4102 20.1602 11.25 19.125 11.25H14.625C14.1277 11.25 13.6508 11.0525 13.2992 10.7008C12.9475 10.3492 12.75 9.87228 12.75 9.375V4.875ZM4.875 14.25C4.66821 14.25 4.5 14.4182 4.5 14.625V19.125C4.5 19.2245 4.53951 19.3198 4.60984 19.3902C4.68016 19.4605 4.77554 19.5 4.875 19.5H9.375C9.58179 19.5 9.75 19.3318 9.75 19.125V14.625C9.75 14.4182 9.58179 14.25 9.375 14.25H4.875ZM3 14.625C3 13.5898 3.83979 12.75 4.875 12.75H9.375C10.4102 12.75 11.25 13.5898 11.25 14.625V19.125C11.25 20.1602 10.4102 21 9.375 21H4.875C4.37772 21 3.90081 20.8025 3.54917 20.4508C3.19754 20.0992 3 19.6223 3 19.125V14.625Z"
        fill="currentColor"
      />
      <path
        d="M6.75 6.75H7.5V7.5H6.75V6.75ZM6.75 16.5H7.5V17.25H6.75V16.5ZM16.5 6.75H17.25V7.5H16.5V6.75ZM13.5 13.5H14.25V14.25H13.5V13.5ZM13.5 19.5H14.25V20.25H13.5V19.5ZM19.5 13.5H20.25V14.25H19.5V13.5ZM19.5 19.5H20.25V20.25H19.5V19.5ZM16.5 16.5H17.25V17.25H16.5V16.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default QR;
